/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse brings together specialized tools crafted for peak performance. Every pixel — designed with intent.`)
};

const es_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse reúne herramientas especializadas creadas para el máximo rendimiento. Cada píxel — diseñado con intención.`)
};

const de_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse vereint spezialisierte Werkzeuge für Höchstleistung. Jedes Pixel — mit Absicht gestaltet.`)
};

const nl_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse brengt gespecialiseerde tools samen voor topprestaties. Elk pixel — met intentie ontworpen.`)
};

const fr_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse rassemble des outils spécialisés conçus pour des performances optimales. Chaque pixel — pensé avec intention.`)
};

const it_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse riunisce strumenti specializzati per prestazioni al massimo. Ogni pixel — progettato con intenzione.`)
};

const pt_br2_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse reúne ferramentas especializadas para desempenho máximo. Cada pixel — projetado com intenção.`)
};

const pt_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Toolverse reúne ferramentas especializadas para desempenho máximo. Cada pixel — concebido com intenção.`)
};

const ja_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverseは最高のパフォーマンスのために作られた専門ツールを集めています。すべてのピクセル — 意図をもって設計。`)
};

const zh_home_hero_subtitle = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toolverse 汇聚专为极致性能打造的专业工具。每一个像素 — 皆有其用意。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_subtitle(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_subtitle", locale)
	if (locale === "en") return en_home_hero_subtitle(inputs)
	if (locale === "es") return es_home_hero_subtitle(inputs)
	if (locale === "de") return de_home_hero_subtitle(inputs)
	if (locale === "nl") return nl_home_hero_subtitle(inputs)
	if (locale === "fr") return fr_home_hero_subtitle(inputs)
	if (locale === "it") return it_home_hero_subtitle(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_subtitle(inputs)
	if (locale === "pt") return pt_home_hero_subtitle(inputs)
	if (locale === "ja") return ja_home_hero_subtitle(inputs)
	return zh_home_hero_subtitle(inputs)
};